.partner-shell {
  --partner-blue: #075fc9;
}
.partner-avatar {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb423, #ef7d08);
  color: white;
  display: grid;
  place-items: center;
  font-weight: 850;
  font-size: 11px;
  flex: 0 0 auto;
}
.partner-avatar.small {
  width: 34px;
  height: 34px;
}
.partner-shell .profile {
  gap: 9px;
}
.partner-shell .profile > div:nth-child(2) {
  min-width: 0;
  flex: 1;
}
.partner-shell .profile b {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 125px;
}
.partner-overview-grid {
  display: grid;
  grid-template-columns: 1.45fr 0.75fr;
  gap: 16px;
}
.partner-table-panel,
.performance-card {
  padding: 19px;
}
.performance-card {
  min-height: 310px;
}
.offer-performance {
  padding-top: 16px;
}
.offer-performance > div {
  display: grid;
  grid-template-columns: 13px 1fr auto;
  gap: 8px;
  align-items: center;
  padding: 10px 0;
}
.offer-performance b {
  font-size: 11px;
}
.offer-performance em {
  font-style: normal;
  color: var(--muted);
  font-size: 9px;
}
.offer-performance > div > div {
  grid-column: 2/4;
  height: 6px;
  background: #eef2f7;
  border-radius: 8px;
  overflow: hidden;
}
.offer-performance i {
  display: block;
  height: 100%;
  min-width: 3%;
  background: linear-gradient(90deg, #0862d6, #5ba6ff);
  border-radius: 8px;
}
.performance-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #0965d9;
}
.performance-dot.p1 {
  background: #13a565;
}
.performance-dot.p2 {
  background: #f2a21c;
}
.performance-dot.p3 {
  background: #8a51d4;
}
.performance-dot.p4 {
  background: #e55762;
}
.partner-tip {
  margin-top: 16px;
}
.partner-empty {
  text-align: center;
  padding: 65px 30px;
  margin-top: 30px;
}
.partner-empty > div {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #fff0d5;
  color: #b66c00;
  font-size: 28px;
  font-weight: 900;
  margin: auto;
}
.partner-empty h2 {
  font-size: 20px;
  margin: 18px 0 8px;
}
.partner-empty p {
  color: var(--muted);
}
.validation-layout {
  display: grid;
  grid-template-columns: minmax(320px, 0.8fr) minmax(380px, 1.2fr);
  gap: 16px;
}
.scanner-card,
.validation-result {
  padding: 24px;
}
.scanner-card > p {
  font-size: 11px;
  color: var(--muted);
}
.qr-target {
  width: 100%;
  height: 185px;
  border: 2px dashed #a9c5e8;
  border-radius: 12px;
  background: #f5f9ff;
  color: #1267ca;
  display: grid;
  place-content: center;
  gap: 7px;
  cursor: pointer;
  margin: 18px 0;
}
.qr-target span {
  font-size: 58px;
  line-height: 1;
}
.qr-target small {
  font-weight: 700;
}
.or {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #8795a6;
  font-size: 9px;
  margin: 18px 0;
}
.or:before,
.or:after {
  content: "";
  height: 1px;
  background: #e4eaf1;
  flex: 1;
}
.scanner-card .primary {
  margin-top: 14px;
}
.validation-result {
  min-height: 500px;
}
.validation-placeholder {
  min-height: 400px;
  display: grid;
  place-content: center;
  text-align: center;
  color: #9aa6b4;
}
.validation-placeholder div {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #e6f8ee;
  color: #0b9252;
  font-size: 33px;
  margin: auto;
}
.validation-placeholder p {
  max-width: 280px;
  line-height: 1.6;
}
.validation-banner {
  padding: 12px 15px;
  border-radius: 8px;
  font-weight: 800;
  margin: 16px 0;
}
.validation-banner.ok {
  background: #e1f8eb;
  color: #087844;
}
.validation-banner.denied {
  background: #ffe3e5;
  color: #b5222c;
}
.validated-member {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 0;
  border-bottom: 1px solid var(--border);
}
.validated-member img {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  object-fit: cover;
}
.validated-member h2 {
  font-size: 19px;
  margin: 0 0 8px;
}
.validated-member small,
.validated-member b {
  display: block;
}
.validated-member small {
  font-size: 9px;
  color: var(--muted);
}
.validation-facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 18px 0;
}
.validation-facts > div {
  background: #f7f9fc;
  border-radius: 9px;
  padding: 13px;
}
.validation-facts small,
.validation-facts b {
  display: block;
}
.validation-facts small {
  font-size: 9px;
  color: var(--muted);
  margin-bottom: 6px;
}
.validation-action {
  border: 0;
  background: #0d9658;
  color: white;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  font-weight: 750;
  margin: 14px 0 9px;
  cursor: pointer;
}
.status-legend {
  margin-top: 15px;
  padding: 16px;
  display: flex;
  gap: 22px;
  align-items: center;
  flex-wrap: wrap;
}
.status-legend span {
  font-size: 10px;
  color: #59677a;
}
.status-legend i {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}
.status-legend i.green {
  background: #16a060;
}
.status-legend i.yellow {
  background: #e7ac24;
}
.status-legend i.red {
  background: #e14951;
}
.status-legend i.gray {
  background: #929dab;
}
.offer-count {
  display: flex;
  justify-content: space-between;
  background: #f5f8fc;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  padding: 12px 15px;
  color: #667487;
}
.offer-count b {
  font-size: 11px;
}
.offer-count span {
  font-size: 10px;
}
.offer-admin-list {
  display: grid;
  gap: 11px;
  margin: 15px 0;
}
.offer-admin {
  display: grid;
  grid-template-columns: 110px minmax(180px, 1.5fr) minmax(80px, 0.5fr) minmax(
      90px,
      0.5fr
    ) minmax(80px, 0.5fr) auto;
  align-items: center;
  gap: 18px;
  padding: 12px;
}
.offer-admin > img {
  width: 110px;
  height: 74px;
  border-radius: 9px;
  object-fit: cover;
}
.offer-admin small {
  display: block;
  color: var(--muted);
  font-size: 9px;
  margin-bottom: 5px;
}
.offer-admin b {
  font-size: 13px;
}
.offer-admin strong {
  font-size: 18px;
  color: #0b9252;
}
.offer-main small {
  margin-top: 5px;
}
.offer-modal {
  width: min(880px, 100%);
}
.offer-edit-grid {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 22px;
}
.offer-image-edit img {
  width: 100%;
  height: 200px;
  border-radius: 11px;
  object-fit: cover;
  margin-bottom: 10px;
}
.offer-image-edit label {
  display: block;
  text-align: center;
  cursor: pointer;
}
.partner-report-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 13px;
  margin-bottom: 15px;
}
.partner-report-cards > div {
  padding: 20px;
}
.partner-report-cards small,
.partner-report-cards p {
  color: var(--muted);
  font-size: 10px;
}
.partner-report-cards h2 {
  font-size: 22px;
  margin: 9px 0;
}
.profile-editor {
  padding: 22px;
}
.profile-media-editor {
  margin-bottom: 20px;
}
.profile-media-editor img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 10px;
}
.profile-media-editor label {
  width: max-content;
  cursor: pointer;
}
.profile-actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 18px;
}
.public-partner-profile {
  overflow: hidden;
  padding-bottom: 25px;
}
.partner-cover {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.partner-profile-head {
  display: flex;
  gap: 18px;
  align-items: center;
  padding: 0 28px;
  margin-top: -36px;
  position: relative;
}
.partner-public-logo {
  width: 86px;
  height: 86px;
  border-radius: 17px;
  background: linear-gradient(135deg, #ffb426, #ec7805);
  border: 5px solid #fff;
  display: grid;
  place-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: 900;
}
.partner-profile-head h2 {
  font-size: 22px;
  margin: 42px 0 5px;
}
.partner-profile-head h2 span {
  color: #0d76d8;
}
.partner-profile-head p {
  margin: 0;
  color: var(--muted);
}
.partner-public-facts {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  padding: 24px 28px;
  border-bottom: 1px solid var(--border);
  font-size: 10px;
  color: #566479;
}
.public-partner-profile > h3 {
  padding: 22px 28px 0;
}
.public-offers {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 13px;
  padding: 8px 28px 25px;
}
.public-offers article {
  position: relative;
  border: 1px solid var(--border);
  border-radius: 11px;
  overflow: hidden;
  background: #fff;
}
.public-offers img {
  width: 100%;
  height: 115px;
  object-fit: cover;
}
.public-offers article > span {
  position: absolute;
  right: 8px;
  top: 8px;
  background: #0a9958;
  color: #fff;
  border-radius: 15px;
  padding: 5px 9px;
  font-size: 10px;
  font-weight: 800;
}
.public-offers b,
.public-offers p {
  display: block;
  padding: 0 12px;
}
.public-offers b {
  font-size: 11px;
  margin-top: 10px;
}
.public-offers p {
  font-size: 9px;
  color: var(--muted);
  line-height: 1.5;
  margin: 6px 0 12px;
}
.partner-conditions {
  margin: 0 28px;
  background: #f4f8fd;
  border-radius: 9px;
  padding: 15px;
}
.partner-conditions p {
  font-size: 10px;
  color: #617086;
  line-height: 1.6;
  margin-bottom: 0;
}
@media (max-width: 1150px) {
  .partner-overview-grid {
    grid-template-columns: 1fr;
  }
  .offer-admin {
    grid-template-columns: 90px 1fr 100px auto;
  }
  .offer-admin > img {
    width: 90px;
  }
  .offer-admin > div:nth-of-type(3),
  .offer-admin > div:nth-of-type(4) {
    display: none;
  }
  .public-offers {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 900px) {
  .validation-layout {
    grid-template-columns: 1fr;
  }
  .partner-report-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  .public-offers {
    grid-template-columns: repeat(2, 1fr);
  }
  .partner-cover {
    height: 240px;
  }
}
@media (max-width: 600px) {
  .offer-admin {
    grid-template-columns: 82px 1fr auto;
    gap: 10px;
  }
  .offer-admin > img {
    width: 82px;
    height: 65px;
  }
  .offer-admin > div:not(.offer-main) {
    display: none;
  }
  .offer-edit-grid {
    grid-template-columns: 1fr;
  }
  .partner-report-cards {
    grid-template-columns: 1fr 1fr;
  }
  .partner-cover {
    height: 190px;
  }
  .partner-profile-head {
    padding: 0 15px;
  }
  .partner-profile-head h2 {
    font-size: 17px;
  }
  .partner-public-logo {
    width: 70px;
    height: 70px;
  }
  .partner-public-facts,
  .public-offers {
    padding-left: 15px;
    padding-right: 15px;
  }
  .public-offers {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .public-offers img {
    height: 95px;
  }
  .partner-conditions {
    margin: 0 15px;
  }
  .status-legend {
    gap: 11px;
  }
  .scanner-card,
  .validation-result {
    padding: 17px;
  }
}
